import React from 'react';
import white from './white.svg';

type ImgProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export type LogoWhiteProps = Omit<ImgProps, 'src' | 'alt'>

export function LogoWhite(props: LogoWhiteProps) {
    return <img src={white} alt="LCMS Logo" {...props} />
}